import { render, staticRenderFns } from "./Augmentations.vue?vue&type=template&id=21f5987e&scoped=true&"
import script from "./Augmentations.vue?vue&type=script&lang=js&"
export * from "./Augmentations.vue?vue&type=script&lang=js&"
import style0 from "./Augmentations.vue?vue&type=style&index=0&id=21f5987e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5987e",
  null
  
)

export default component.exports